module.exports = __webpack_public_path__ + "static/media/shells_ipad_vscode-fs8.4cfc8dfb.png";